<template>
  <div class="container-page big">
    <HeaderBlock v-if="isAccessAllowed" title="Расследования ЕЭК">
      <div class="header-block-measure__interaction">
        <div class="header-block-measure__interaction-left">
          <ButtonComponent
            v-permission="permissions.create"
            mod="gradient-bg"
            class="button-redesign--mobile-full"
            @click="editCard(0)"
            >Создать</ButtonComponent
          >
          <ButtonComponent mod="gradient-bg" class="button-redesign--mobile-full" @click="clearFilter"
            >Очистить фильтр</ButtonComponent
          >
        </div>
        <div class="header-block-measure__interaction-right">
          <div v-permission="permissions.edit" class="change-status-block">
            <p class="change-status-block__title">Изменение статуса</p>
            <div class="change-status-block__wrapper-select">
              <div class="change-status-block__select">
                <SelectMultiComponent
                  v-model="selectedStatusId"
                  :options="getStatusOptions"
                  placeholder="Не указано"
                  modifier="rectangular"
                  classSelect="visible-clear"
                />
              </div>
              <div class="change-status-block__icon">
                <IconComponent @click="changeStatus" name="add_icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeaderBlock>

    <div v-if="isAccessAllowed" class="table-shadow">
      <div class="table-container-base table-container-base--sort js-table-arrow">
        <table>
          <thead>
            <tr>
              <th class="column-icon"></th>
              <th class="column-46">
                <input type="checkbox" v-model="selectAll" :value="true" />
              </th>
              <th class="sort width-226">Товар</th>
              <th class="sort width-226">Тип расследования</th>
              <th class="sort width-226">Коды ТН ВЭД ЕАЭС</th>
              <th class="sort width-226">Страна-экспортер</th>
              <th class="sort width-226">Дата начала расследования</th>
              <th class="sort width-226">Дата завершения расследования</th>
              <th class="sort width-226">Решение Коллегии ЕЭК</th>
              <th class="sort width-226">Компании-заявители</th>
              <th class="sort width-226">Страна базирования компаний-заявителей</th>
              <th class="sort width-226">Компании, поддерживающие заявление</th>
              <th class="sort width-226">Страна базирования компаний, поддерживающих заявление</th>
              <th class="sort width-226">Статус</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>
                <ComponentInput
                  placeholder="Товар"
                  mod="filter-small"
                  v-model="filter.tnvedGroup"
                  clearButton
                  @onClear="filter.tnvedGroup = ''"
                />
              </th>
              <th>
                <SelectMultiComponent
                  v-model="filter.investigationTypeId"
                  :options="investigationTypes"
                  placeholder="Экспортеры"
                  modifier="filter-small"
                  classSelect="visible-clear"
                />
              </th>
              <th>
                <ComponentInput
                  placeholder="Код ТН ВЭД ЕАЭС"
                  mod="filter-small"
                  v-model="filter.tnvedCodes"
                  clearButton
                  @onClear="filter.tnvedCodes = ''"
                />
              </th>
              <th>
                <SelectMultiComponent
                  v-model="filter.countryExporterId"
                  :options="getCountriesMultiSelect"
                  placeholder="Экспортеры"
                  modifier="filter-small"
                  classSelect="visible-clear"
                />
              </th>
              <th>
                <div class="horizontally-date">
                  <DateComponent v-model="filter.startDateFrom" modClass="filter-small" />
                  <DateComponent v-model="filter.startDateTo" modClass="filter-small" />
                </div>
              </th>
              <th>
                <div class="horizontally-date">
                  <DateComponent v-model="filter.finishDateFrom" modClass="filter-small" />
                  <DateComponent v-model="filter.finishDateTo" modClass="filter-small" />
                </div>
              </th>
              <th>
                <ComponentInput
                  placeholder="Введите"
                  mod="filter-small"
                  v-model="filter.decision"
                  clearButton
                  @onClear="filter.decision = ''"
                />
              </th>
              <th>
                <ComponentInput
                  placeholder="Введите"
                  mod="filter-small"
                  v-model="filter.companyApplicants"
                  clearButton
                  @onClear="filter.companyApplicants = ''"
                />
              </th>
              <th>
                <SelectMultiComponent
                  v-model="filter.countryApplicantId"
                  :options="getCountriesMultiSelect"
                  placeholder="Экспортеры"
                  modifier="filter-small"
                  classSelect="visible-clear"
                />
              </th>
              <th>
                <ComponentInput
                  placeholder="Введите"
                  mod="filter-small"
                  v-model="filter.companySupportives"
                  clearButton
                  @onClear="filter.companySupportives = ''"
                />
              </th>
              <th>
                <SelectMultiComponent
                  v-model="filter.countrySupportiveId"
                  :options="getCountriesMultiSelect"
                  placeholder="Экспортеры"
                  modifier="filter-small"
                  classSelect="visible-clear"
                />
              </th>
              <th>
                <SelectMultiComponent
                  v-model="filter.isActive"
                  :options="getStatusOptions"
                  placeholder="Выберите"
                  modifier="filter-small"
                  classSelect="visible-clear"
                />
              </th>
            </tr>
          </thead>
          <TableBody :itemsBody="page.items" :isLoading="isLoading">
            <tr v-for="item in page.items" :key="item.id" @dblclick="editCard(item.id)">
              <td>
                <div class="wrap-icon">
                  <IconComponent
                    v-permission="permissions.edit"
                    class="icon--full-svg"
                    @click="editCard(item.id)"
                    name="edit"
                  />
                  <IconComponent
                    v-permission="permissions.delete"
                    class="icon--full-svg delete"
                    @click="deleteCard(item.id)"
                    name="delete-not-fill"
                  />
                </div>
              </td>
              <td>
                <input type="checkbox" v-model="selectedIds" :value="item.id" />
              </td>
              <td>{{ item.tnvedGroup.name }}</td>
              <td>{{ item.investigationType.name }}</td>
              <td>{{ item.tnveds?.map((x) => x.code)?.join(', ') }}</td>
              <td>{{ item.countryExporters?.map((x) => x.name)?.join(', ') }}</td>
              <td>{{ $momentFormat(item.startDate, 'DD.MM.YYYY') }}</td>
              <td>{{ $momentFormat(item.finishDate, 'DD.MM.YYYY') }}</td>
              <td>{{ item.decision }}</td>
              <td>{{ item.companyApplicants }}</td>
              <td>{{ item.countryApplicants?.map((x) => x.name)?.join(', ') }}</td>
              <td>{{ item.companySupportives }}</td>
              <td>{{ item.countrySupportives?.map((x) => x.name)?.join(', ') }}</td>
              <td>{{ item.isActive ? 'действ.' : 'не действ.' }}</td>
            </tr>
          </TableBody>
        </table>
      </div>
    </div>

    <PaginationRedesigned
      v-if="isAccessAllowed && page.pagesTotal > 1"
      :pageCount="page.pagesTotal"
      :currentPage="page.pageNumber"
      @change="onPageChange($event, false)"
      @more="onPageChange($event, true)"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { debounce } from 'lodash';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import TableBody from '@/common/components/redesigned/TableBody.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import removeEmptyValuesFromObject from '@/common/mixins/removeEmptyValuesFromObject';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import Api from '../api/eecinvestigation';
  import HeaderBlock from '../components/HeaderBlock.vue';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  const PERMISSIONS = {
    view: Constants.Permissions.EecInvestigationView,
    create: Constants.Permissions.EecInvestigationCreate,
    edit: Constants.Permissions.EecInvestigationEdit,
    delete: Constants.Permissions.EecInvestigationDelete,
  };

  export default {
    name: 'EecInvestigationRegistry',
    components: {
      IconComponent,
      HeaderBlock,
      ButtonComponent,
      SelectMultiComponent,
      ComponentInput,
      DateComponent,
      PaginationRedesigned,
      TableBody,
    },
    mixins: [security, removeEmptyValuesFromObject],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        isLoading: false,
        filter: {},
        selectedIds: [],
        selectAll: false,
        selectedStatusId: null,
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;
        this.loadDictionaries();
        this.loadPage(false);
      });
    },
    computed: {
      ...mapGetters({
        getCountriesMultiSelect: DIRECTIVES_GETTERS_NAME.getCountriesMultiSelect,
        investigationTypes: DIRECTIVES_GETTERS_NAME.getNSIInvestigationTypeList,
      }),

      permissions: () => PERMISSIONS,

      getStatusOptions() {
        return Constants.statusOptions.map((i) => ({ value: i.id, label: i.text }));
      },
    },
    methods: {
      ...mapActions({
        countriesGet: DIRECTIVES_ACTIONS_NAME.countriesGet,
        getNSIInvestigationType: DIRECTIVES_ACTIONS_NAME.getNSIInvestigationType,
      }),

      loadDictionaries() {
        this.getNSIInvestigationType();
        this.countriesGet();
      },

      loadPage(append) {
        this.isLoading = !append;
        const dataFilter = this.objectFormatter(this.filter);
        if (dataFilter?.isActive) dataFilter.isActive = dataFilter.isActive === 1;
        if (dataFilter?.countryExporterId) dataFilter.countryExporterIds = [dataFilter.countryExporterId];
        if (dataFilter?.countryApplicantId) dataFilter.countryApplicantIds = [dataFilter.countryApplicantId];
        if (dataFilter?.investigationTypeId) dataFilter.investigationTypeIds = [dataFilter.investigationTypeId];
        if (dataFilter?.countrySupportiveId) dataFilter.countrySupportiveIds = [dataFilter.countrySupportiveId];

        Api.search({
          ...this.request,
          ...dataFilter,
        })
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },

      editCard(id) {
        this.$router.push({ name: 'EecInvestigationCard', params: { id: id, action: 'edit' } });
      },

      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            Api.delete(id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена.',
                  'error',
                );
              });
          }
        });
      },

      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },

      changeFilter: debounce(function () {
        this.request.pageNumber = 1;
        this.loadPage(false);
      }, 500),

      clearFilter() {
        this.filter = {};
        this.changeFilter();
      },

      changeStatus() {
        if (!this.selectedIds.length || !this.selectedStatusId) {
          return;
        }
        Api.changeStatusMulti({
          ids: this.selectedIds,
          statusId: this.selectedStatusId,
        })
          .then(() => {
            Constants.alert.fire('Изменение статуса', `Статус записей успешно изменен.`, 'success');
            this.clearSelection();
            this.loadPage();
          })
          .catch((error) => {
            Constants.alert.fire('Изменение статуса', Constants.commonError, 'error');
            console.error(error?.response?.data);
          });
      },

      clearSelection() {
        this.selectedIds = [];
      },
    },
    watch: {
      selectAll(value) {
        if (value) {
          this.selectedIds = [];
          this.selectedIds.push(...this.page.items.map((x) => x.id));
        } else {
          this.clearSelection();
        }
      },

      filter: {
        handler() {
          this.changeFilter();
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/index.scss';
  @import '@/assets/theme/default/table/table-base.scss';
</style>
